import React from 'react';
import { InvoiceListContext, initState } from '../hooks/useInvoiceList';

export const InvoiceListProvider = ({ children }: { children: React.ReactNode }) => {
  const [dueState, setDueState] = React.useState(initState());
  const [paidState, setPaidState] = React.useState(initState());

  const clearAll = React.useCallback(() => {
    setDueState(initState());
    setPaidState(initState());
  }, []);

  const value = React.useMemo(
    () => ({ dueState, setDueState, paidState, setPaidState, clearAll }),
    [dueState, paidState, clearAll],
  );

  return <InvoiceListContext.Provider value={value}>{children}</InvoiceListContext.Provider>;
};
